import React, { useEffect, useState } from "react";
import styles from "./allOffers.module.css";
import { ALLOFFERS } from "../../../../../../Api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Axios } from "../../../../../../Api/Axios";

const AllOffers = () => {
  const [allOffers, setAllOffers] = useState([]);

  useEffect(() => {
    const getOffers = async () => {
      try {
        const res = await Axios.get(`/${ALLOFFERS}`);
        setAllOffers(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOffers();
  }, []);

  // console.log(allOffers);

  const mapAllOffers = allOffers.map((offer) => (
    <tr key={offer.id}>
      <td>
        <div className="d-flex align-items-center gap-2">
          {/* <img
            src={
              offer.investor.profilePicture
                ? `data:image/jpeg;base64,${offer.investor.profilePicture}`
                : require("../../../../../../Assets/Images/profile.jpg")
            }
            alt="investor"
            className="rounded-circle me-2"
            style={{ width: "40px", height: "40px", objectFit: "cover" }}
          /> */}
          <div style={{ fontSize: "20px" }}>
            <FontAwesomeIcon icon={faUser} />
          </div>
          <span>{offer.title}</span>
        </div>
      </td>

      <td>${offer.amount}/month</td>
      <td
        style={{
          maxWidth: "200px",
          whiteSpace: "normal",
          wordWrap: "break-word",
        }}
      >
        {offer.notes}
      </td>
      <td>
        <span
          className={`badge m-0 ${
            offer.status === "pendingAdminApproval"
              ? "text-bg-warning"
              : offer.status === "adminAccepted"
              ? "text-bg-success"
              : offer.status === "adminRejected"
              ? "text-bg-danger"
              : offer.status === "talentRejected"
              ? "text-bg-danger"
              : "text-bg-primary"
          }`}
        >
          {offer.status === "pendingAdminApproval"
            ? "Offer Pending By Admin"
            : offer.status === "adminAccepted"
            ? "Offer Accepted By Admin"
            : offer.status === "adminRejected"
            ? "Offer Rejected By Admin"
            : offer.status === "talentRejected"
            ? "Offer Rejected By Talent"
            : "Talent Accepted"}
        </span>
      </td>
    </tr>
  ));

  return (
    <div className={`${styles.rightSide} bg-white mt-2`}>
      <h1>All Offers</h1>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Title</th>
              <th>Amount</th>
              <th>Notes</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {mapAllOffers.length > 0 ? (
              mapAllOffers
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No offers
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllOffers;
